export default [
  //    - Owners list
  {
    path: "/owners",
    name: "foravila-owners-list",
    component: () => import("@/views/owners/list/OwnersList.vue"),
    meta: {
      action: "manage",
      resource: "administration",
      pageTitle: "Llistat de propietaris",
      breadcrumb: [{ text: "Propietaris" }, { text: "Llistat", active: true }],
    },
  },
  //    - New owner
  {
    path: "/owners/new",
    name: "foravila-new-owner",
    component: () => import("@/views/owners/new-owner/NewOwner.vue"),
    meta: {
      action: "manage",
      resource: "all",
      pageTitle: "Nou propietari",
      breadcrumb: [{ text: "Propietaris" }, { text: "Nou", active: true }],
    },
  },
  //    - Owner view
  {
    path: "/owners/:ownerUuid",
    name: "foravila-owner-view",
    component: () => import("@/views/owners/owner/OwnerView.vue"),
    meta: {
      action: "manage",
      resource: "administration",
      pageTitle: "Detalls del propietari",
      breadcrumb: [
        { text: "Propietaris" },
        { text: "Propietari", active: true },
      ],
    },
  },
];
